module.exports = __webpack_public_path__ + "static/media/YF52_10.66979a58.jpg";